import React, { useState } from 'react'
import { IMainStepData, IMainStepEdit } from '../../../../../models/freshman/mainStep'
import { cloneDeep } from '../../../../../constants/commonConstants';
import FloatingLabelTextInput from '../../../../../common-components/floatingtextinput';
import Joi from 'joi';
import { validateFields } from '../../../../../helper/joi-validation';
import { alertConstants, getAlertData } from '../../../../../helper/sweet-alert';
import { connect } from 'react-redux';
import { updateMainStep } from '../../../../../action/freshman/mainstepActionCreator';
import SweetAlert from 'react-bootstrap-sweetalert';
import LoaderSpinner from '../../../../../common-components/loader';

const MainStepEdit = (props: IMainStepEdit) => {
    const { getAllMainSteps, updateMainStep, mainStep, setShowEdit } = props

    const [data, setData] = useState<IMainStepData>(cloneDeep(mainStep));
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<any>("success");
    const [alertTitle, setAlertTitle] = useState<string>("Default");
    const [errors, setErrors] = useState<any>(undefined);
    const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)

    // change the data at the time onchange fields
    const onChange = (
        event:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        errors && delete errors[event.target.name];
        const _data = { ...data, [event.target.name]: event.target.value };
        setData(_data);
    };

    const schema = Joi.object().keys({
        name: Joi.string().required().label("Name is required"),
    });

    // setting sweet alert dynamically
    const setAlert = (type: string) => {
        let alertData = getAlertData(type);
        if (alertData) {
            setShowAlert(true);
            setAlertType(alertData.type);
            setAlertTitle(alertData.title);
        }
    };

    const onUpdate = async () => {
        const cleanedData = {
            ...data,
            name: data.name.trim().replace(/\s+/g, ' '),
        };
    
        const validationErrors = validateFields(cleanedData, schema);
        if (validationErrors === undefined) {
            setLoading(true)
            setIsDisabled(true)
            try {
                await updateMainStep(cleanedData, cleanedData.id ?? 0, setAlert);
            } finally {
                setLoading(false)
                setIsDisabled(false)
            }
        } else {
            setErrors(validationErrors);
        }
    };

    // executed on clicking 'OK' in sweet alert.
    const onConfirm = () => {
        if (alertType === alertConstants.error) {
            setShowAlert(false);
        } else {
            getAllMainSteps(true);
            setShowEdit(false);
        }
    };

    //setting warning alert on cancel
    const onCancel = async () => {
        setShowAlertCancel(true);
        setAlert(alertConstants.cancelCheck);
    };

    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="addnewbuttonsLabel">Update Main Task</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowEdit(false)}></button>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-lg-12 form-group">
                        <FloatingLabelTextInput
                            label={"Name "}
                            onChange={onChange}
                            isMandatory={true}
                            value={data.name}
                            name={"name"}
                            maxLength={50}
                        />
                        {errors?.name && <div className="text-danger">{errors.name}</div>}
                    </div>
                    <div className="col-lg-12 form-group">
                        <label className="profile_details_text">Description</label>
                        <textarea
                            name="description"
                            value={data.description}
                            onChange={onChange}
                            maxLength={1000}
                            required
                        >
                            {" "}
                        </textarea>
                        {errors?.description && <div className="text-danger">{errors.description}</div>}
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onUpdate}
                        disabled={isDisabled}>
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowEdit(false)}>
                        Close
                    </button>
                </div>
            </div>
            <SweetAlert
                show={showAlert}
                success={false}
                type={alertType}
                title={alertTitle}
                onConfirm={() => onConfirm()}
                showCancel={showAlertCancel}
                onCancel={() => {
                    setShowAlert(false);
                    setShowAlertCancel(false);
                }}
                cancelBtnText={"No"}
                confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
            ></SweetAlert>
            {loading && (<LoaderSpinner />)}
        </>
    )
}

const mapDispatchToProps = {
    updateMainStep: (data: IMainStepData, id: number, callBack: Function) =>
        updateMainStep(data, id, callBack),
};

function mapStateToProps(state: any) {

}

export default connect(mapStateToProps, mapDispatchToProps)(MainStepEdit);